/* Kill parallax object-position writes on mobile.
   content.9gtb.com (third-party app) writes img.style.objectPosition
   on every scroll event. We can't patch the prototype because it loads
   after us and restores it. Instead we use a rAF loop to strip the
   inline style immediately after it's written, on mobile only.
*/
(function() {
  if (window.innerWidth >= 990) return;

  var targets = [];

  function collectTargets() {
    targets = Array.from(document.querySelectorAll(
      '.evdnce-hero img, .evdnce-gender-split img, .media-position--background img'
    ));
  }

  function strip() {
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].style.objectPosition) {
        targets[i].style.objectPosition = '';
      }
    }
    requestAnimationFrame(strip);
  }

  document.addEventListener('DOMContentLoaded', function() {
    collectTargets();
    requestAnimationFrame(strip);
  });

  // Re-collect if new sections load
  window.addEventListener('shopify:section:load', collectTargets);
})();
